// extracted by mini-css-extract-plugin
export default {"base":"vp_Xrb7H","button":"vp_Ypvpr","icon":"vp_xyPGL","label":"vp_nTMU7","count":"vp_aQntB","number":"vp_LqfE3","active":"vp_SPfbe","embedded":"vp_eNAD8"};